import { MulticastChannel } from 'redux-saga';
import { fork, take } from 'typed-redux-saga';

export function* multicastTakeEvery<T extends object>(channel: MulticastChannel<T>, worker: (arg: T) => void) {
    return yield* fork(function* () {
        while (true) {
            const value = yield* take(channel, '*');

            yield* fork(worker, value);
        }
    });
}
